import { useLocation, useParams, useNavigate } from 'react-router-dom';
import './TPDSDeviation.css';
import React, { useState, useEffect, useCallback } from 'react';
import { jsPDF } from 'jspdf';
import pds from './pds.PNG';
import ExcelJS from 'exceljs';
import { format } from 'date-fns';
import axios from 'axios';
const TPDSDeviation = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const [selectedDistrictName, setSelectedDistrictName] = useState(null);
  const [selectedSubDivision, setSelectedSubDivision] = useState(null);
  const [selectedBlock, setSelectedBlock] = useState(null);
  const [district, setDistrict] = useState([]);
  const [districtData, setDistrictData] = useState([]);  // Initialize with empty array
  const [dateRange, setDateRange] = useState('');
  const [selectedPanchyat, setSelectedPanchayat] = useState(null);
  const [blocks, setBlocks] = useState([]);  // Initialize as an empty array
  const [panchayats, setPanchayats] = useState([]);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  const [data, setData] = useState([]);
  const [subDivisions, setSubDivisions] = useState([]);  // Initialize as an empty array
  const queryParams = new URLSearchParams(location.search);
  const eposStock = queryParams.get('eposStock');
  const physicalStock = queryParams.get('physicalStock');
  const [currentLevel, setCurrentLevel] = useState("district");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [loading, setLoading] = useState(true);
  const [formattedFromDate, setFormattedFromDate] = useState("");
  const token = `${process.env.REACT_APP_AFTER_TOKEN}`;


  const baseUrl = `${process.env.REACT_APP_API_BASE_URL}/dashboard-data/stocks`;
  useEffect(() => {
    const storedFromDate = localStorage.getItem('formattedFromDateForQtl');
    const storedToDate = localStorage.getItem('formateedToDateForQtl');

    if (storedFromDate && storedToDate) {
      const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${year}-${month}-${day}`;
      };

      const formattedFrom = formatDate(storedFromDate);
      const formattedTo = formatDate(storedToDate);

      setFromDate(formattedFrom);
      setToDate(formattedTo);

      fetchDistrictData(formattedFrom, formattedTo); // Call once on mount
    } else {
      console.error('No date found in localStorage');
    }
  }, []); // <-- only runs once on mount


  const fetchDistrictData = (from, to) => {
    const apiUrl = `${baseUrl}/all-districts/from/${from}/to/${to}`;
    axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    })
      .then(response => {
        const sortedData = response.data.sort((a, b) => a.name.localeCompare(b.name));
        setDistrictData(sortedData);
      })
      .catch(error => console.error('Error fetching data:', error));
  };


  const fetchSubDivisionData = (districtUid) => {
    if (districtUid && fromDate && toDate) {
      const apiUrl = `${baseUrl}/district/${districtUid}/from/${fromDate}/to/${toDate}`;
      axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      })
        .then(response => {
          const sortedSubDivisions = response.data.sort((a, b) => a.name.localeCompare(b.name));
          setSubDivisions(sortedSubDivisions);
        })
        .catch(error => console.error('Error fetching subdivision data:', error));
    } else {
      console.error('Missing parameters!');
    }
  };

  const fetchBlockData = (subDivisionUid) => {
    if (subDivisionUid && fromDate && toDate) {
      const apiUrl = `${baseUrl}/subdivision/${subDivisionUid}/from/${fromDate}/to/${toDate}`;
      axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      })
        .then(response => {
          const sortedBlocks = response.data.sort((a, b) => a.name.localeCompare(b.name));
          setBlocks(sortedBlocks);
        })
        .catch(error => console.error('Error fetching block data:', error));
    }
  };



  const fetchPanchayatData = (blockUid) => {
    if (blockUid && fromDate && toDate) {
      const apiUrl = `${baseUrl}/block/${blockUid}/from/${fromDate}/to/${toDate}`;
      axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      })
        .then(response => {
          const sortedPanchayats = response.data.sort((a, b) => a.name.localeCompare(b.name));
          setPanchayats(sortedPanchayats);
        })
        .catch(error => console.error('Error fetching panchayat data:', error));
    }
  };

  const formattedEposStock = (stock) => {
    return stock ? stock.toFixed(2) : "N/A"; // Formatting ePOS stock
  };

  const formattedPhysicalStock = (stock) => {
    return stock ? stock.toFixed(2) : "N/A"; // Formatting physical stock
  };

  const formatNumber = (number) => {
    return new Intl.NumberFormat('en-IN').format(number); // 'en-IN' for Indian number formatting (commas at appropriate positions)
  };


  const formatDecimal = (value, decimalPlaces = 2) => {
    if (value !== null && value !== undefined) {
      const numberValue = parseFloat(value);
      if (!isNaN(numberValue)) {
        return numberValue.toFixed(decimalPlaces); // Limit to 2 decimal places
      }
    }
    return '0.00'; // Default if the value is not provided or invalid
  };


  // Function to download the table as a PDF
  const downloadPDF = () => {
    const doc = new jsPDF();
    doc.addImage(pds, 'jpeg', 9.5, 10, 190, 30); // Image format: 'JPEG'
    doc.setFontSize(18);
    // Get the current date
    const currentDate = new Date();
    // Format the date as dd-mm-yyyy
    const day = String(currentDate.getDate()).padStart(2, '0'); // Get day and pad with zero if needed
    const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Get month (months are 0-indexed)
    const year = currentDate.getFullYear(); // Get the year
    const formattedDate = `${day}-${month}-${year}`; // Format as dd-mm-yyyy
    // Now use the formatted date in doc.text()
    doc.text(`TPDS Deviation in Stock Quantity (Qtl)`, 50, 40);

    let yPosition = 45; // Starting Y position
    // Format the time as HH:mm:ss
    const formattedTime = `${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;
    // Combine both date and time into one string
    const formattedDateTime = `${formattedDate} ${formattedTime}`;
    // Set the date text color (black) and make it bold
    doc.setFont('helvetica', 'bold'); // Use Helvetica font and bold style
    doc.setTextColor(0, 0, 0);  // Black color for the date
    doc.setFontSize(12);
    // Add the current date and time to the PDF, positioned at the bottom-right corner
    doc.text(`Report Date: ${formattedDateTime}`, 196, yPosition + 13, { align: 'right' });
    yPosition += 5;

    //let tableData = []; // This will hold the data for the table
    let title = '';
    let tableData = [];
    const formattedFromDate = localStorage.getItem('formattedFromDateForQtl');
    const formattedToDate = localStorage.getItem('formateedToDateForQtl');
    // Determine which level of data to include
    if (currentLevel === "district") {
      title = `District Wise Inspection Report `;
      // Add title to the PDF
      doc.text(title, 14, yPosition);
      yPosition += 3; // Adjust the yPosition for the date range below the title
      // Format the date range text
      // Set font to normal for the date range and add it below the title
      doc.setFont("helvetica", "normal");
      yPosition += 3; // Move the position down for the table
      // Populate the tableData for district level

      doc.text(`Form Date : ${format(formattedFromDate, 'dd-MM-yyyy')}  To Date : ${format(formattedToDate, "dd-MM-yyyy")}`, 14, yPosition);
      yPosition += 3;
      tableData = districtData.map((district, index) => {
        return [
          index + 1,
          capitalizeFirstLetter(district.name.trim()),
          Math.abs(district.eposRice).toFixed(2),
          Math.abs(district.eposWheat).toFixed(2),
          Math.abs(district.physicalRice).toFixed(2),
          Math.abs(district.physicalWheat).toFixed(2),
          `${Math.abs(district.deviationRicePercent).toFixed(2)}%`, // Append '%' symbol
          `${Math.abs(district.deviationWheatPercent).toFixed(2)}%` // Append '%' symbol
        ];
      });

    } else if (currentLevel === "subdivision") {
      title = `${capitalizeFirstLetter(selectedDistrict)} - Subdivision Wise Inspection Report`;
      // Add title to the PDF
      doc.text(title, 14, yPosition);
      yPosition += 3; // Adjust the yPosition for the date range below the title
      // Format the date range text
      // Set font to normal for the date range and add it below the title
      doc.setFont("helvetica", "normal");
      yPosition += 3; // Move the position down for the table
      // Populate the tableData for subdivision level
      doc.text(`Form Date : ${format(formattedFromDate, 'dd-MM-yyyy')}  To Date : ${format(formattedToDate, "dd-MM-yyyy")}`, 14, yPosition);
      yPosition += 3;
      tableData = filteredData.map((subdivision, index) => {
        // console.log(sortedDistrictData);
        return [
          index + 1,
          capitalizeFirstLetter(subdivision.name.trim()),
          Math.abs(subdivision.eposRice).toFixed(2),
          Math.abs(subdivision.eposWheat).toFixed(2),
          Math.abs(subdivision.physicalRice).toFixed(2),
          Math.abs(subdivision.physicalWheat).toFixed(2),
          `${Math.abs(subdivision.deviationRicePercent).toFixed(2)}%`, // Append '%' symbol
          `${Math.abs(subdivision.deviationWheatPercent).toFixed(2)}%` // Append '%' symbol
        ];
      });
    } else if (currentLevel === "block") {
      title = `${capitalizeFirstLetter(selectedDistrict)} - ${capitalizeFirstLetter(selectedSubDivision)} - Block Wise Inspection Report`;
      // Add title to the PDF
      doc.text(title, 14, yPosition);
      yPosition += 3; // Adjust the yPosition for the date range below the title
      // Set font to normal for the date range and add it below the title
      doc.setFont("helvetica", "normal");
      yPosition += 3; // Move the position down for the table
      doc.text(`Form Date : ${format(formattedFromDate, 'dd-MM-yyyy')}  To Date : ${format(formattedToDate, "dd-MM-yyyy")}`, 14, yPosition);
      yPosition += 3;
      // Populate the tableData for block level
      tableData = filteredData.map((block, index) => {
        return [
          index + 1,
          capitalizeFirstLetter(block.name.trim()),
          Math.abs(block.eposRice).toFixed(2),
          Math.abs(block.eposWheat).toFixed(2),
          Math.abs(block.physicalRice).toFixed(2),
          Math.abs(block.physicalWheat).toFixed(2),
          `${Math.abs(block.deviationRicePercent).toFixed(2)}%`, // Append '%' symbol
          `${Math.abs(block.deviationWheatPercent).toFixed(2)}%` // Append '%' symbol
        ];
      });
    } else if (currentLevel === "panchayat") {
      title = `${capitalizeFirstLetter(selectedDistrict)} - ${capitalizeFirstLetter(selectedSubDivision)} ${capitalizeFirstLetter(selectedBlock)}- Panchyat Wise Inspection Report`;
      // Add title to the PDF
      doc.text(title, 14, yPosition + 2);
      yPosition += 3; // Adjust the yPosition for the date range below the title
      // Set font to normal for the date range and add it below the title
      doc.setFont("helvetica", "normal");
      yPosition += 5; // Move the position down for the table
      doc.text(`Form Date : ${format(formattedFromDate, 'dd-MM-yyyy')}  To Date : ${format(formattedToDate, "dd-MM-yyyy")}`, 14, yPosition);
      yPosition += 4;
      // Check if panchayat is an array before calling map
      if (Array.isArray(panchayats)) {
        tableData = panchayats.map((panchayat, index) => {
          return [
            index + 1,
            capitalizeFirstLetter(panchayat.name.trim()),
            Math.abs(panchayat.eposRice).toFixed(2),
            Math.abs(panchayat.eposWheat).toFixed(2),
            Math.abs(panchayat.physicalRice).toFixed(2),
            Math.abs(panchayat.physicalWheat).toFixed(2),
            `${Math.abs(panchayat.deviationRicePercent).toFixed(2)}%`, // Append '%' symbol
            `${Math.abs(panchayat.deviationWheatPercent).toFixed(2)}%` // Append '%' symbol
          ];
        });
      } else {
        console.error("panchayat is not an array or is undefined:", panchayats);
      }
    }
    yPosition += 3; // Ensure space between the title/date range and the table
    // Table header based on the current level
    let header;
    if (currentLevel === "district" || currentLevel === "subdivision" || currentLevel === "block" || currentLevel === "panchayat") {
      // For subdivision, block, and panchayat, the table will have similar structure to the district table
      header = [
        [
          { content: 'S. No', rowSpan: 2 },
          { content: currentLevel === "district" ? 'district' : currentLevel === "subdivision" ? 'Sub-Division' : currentLevel === "block" ? 'Block' : 'panchayat', rowSpan: 2 },
          { content: 'e-POS Stock(Qtl)', colSpan: 2 },
          { content: 'Physically Verified Quantity(Qtl)', colSpan: 2 },
          { content: '% of Deviation in Stock Quantity (Qtl)', colSpan: 2 },
        ],
        [
          { content: 'Rice' },
          { content: 'Wheat' },
          { content: 'Rice' },
          { content: 'Wheat' },
          { content: 'Rice' },
          { content: 'Wheat' },
        ],
      ];
    }
    // Adding the table with dynamic header and data
    doc.autoTable({
      startY: yPosition,
      head: header,  // Table header is defined here
      body: tableData,  // Table body is populated here
      headStyles: {
        fillColor: [255, 165, 0],  // Header color, change as needed
        textColor: [255, 255, 255],  // Text color for header
        fontSize: 10,
        halign: 'center',  // Center header text
        valign: 'middle',  // Vertically center the text
      },
      styles: {
        fontSize: 9,
        halign: 'center',  // Center-align body text
      },
      columnStyles: {
        1: { halign: 'left' },  // Align Name column to left
        2: { halign: 'right' }, // Align Stock/Quantity columns to right
        3: { halign: 'right' },
        4: { halign: 'right' },
        5: { halign: 'right' },
        6: { halign: 'right' },
      },


      didParseCell: (data) => {
        // Apply background color and text color for the last row (total row)
        if (data.row.index === tableData.length) {  // The last row is the total row
          data.cell.styles.fillColor = [255, 165, 0];  // Background color
          data.cell.styles.textColor = [255, 255, 255];  // Text color
          data.cell.styles.fontSize = 10;  // Font size for total row
        }
      },
    });

    // Save PDF with the dynamic title as filename
    doc.save(`${title.replace(/ /g, '_').replace(/[^a-zA-Z0-9_]/g, '')}.pdf`);
  };



  //console.log("currentLevel : ", currentLevel);
  // Check the populated tableData


  const formatDate = (date) => {
    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, '0'); // Get day and pad with leading zero if necessary
    const month = (d.getMonth() + 1).toString().padStart(2, '0'); // Get month (1-based) and pad with leading zero if necessary
    const year = d.getFullYear(); // Get year

    return `${day}-${month}-${year}`; // Return formatted date in DD-MM-YYYY format
  };



  const filteredData =
    currentLevel === "district" ? data :
      currentLevel === "subdivision" ? subDivisions :
        currentLevel === "block" ? blocks :
          panchayats[selectedBlock] || [];
  // Use staticBlocks as per your existing logic
  const subivisions =
    currentLevel === "subdivision" ? data : currentLevel === "block" ? blocks : blocks[selectedSubDivision] || [];


  const downloadExcel = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('TPDS Deviation in Stock Quantity Report');

    // Set title for the worksheet (merging cells)
    worksheet.mergeCells('A1:H1');
    worksheet.getCell('A1').value = 'TPDS Deviation in Stock Quantity (Qtl)';
    worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.getCell('A1').font = { size: 16, bold: true, color: { argb: 'F7912B' } }; // Text color: Light Steel Blue
    worksheet.getCell('A1').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'F5F5F5' }, // Background color: Whitesmoke
    };

    const currentDate = new Date();

    // Format the date as DD-MM-YYYY
    const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;

    // Format the time as HH:mm:ss
    const formattedTime = `${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;

    // Combine both date and time into one string
    const formattedDateTime = `${formattedDate} ${formattedTime}`;

    // Set title for the worksheet (merging cells)
    worksheet.mergeCells('A2:H2');
    worksheet.getCell('A2').value = `Report Date : ${formattedDateTime}`;
    worksheet.getCell('A2').alignment = { vertical: 'middle', horizontal: 'right' };
    worksheet.getCell('A2').font = { size: 11, bold: true, color: { argb: '000000' } }; // Text color: Black
    worksheet.getCell('A2').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'F5F5F5' }, // Background color: Whitesmoke
    };


    // Set title for the worksheet (merging cells)
    worksheet.mergeCells('A3:H3');
    const formattedFromDate = localStorage.getItem('formattedFromDateForQtl');
    const formattedToDate = localStorage.getItem('formateedToDateForQtl');
    worksheet.getCell('A3').value = `Form Date : ${format(formattedFromDate, 'dd-MM-yyyy')}     To Date : ${format(formattedToDate, "dd-MM-yyyy")}`;
    worksheet.getCell('A3').alignment = { vertical: 'middle', horizontal: 'left' };
    worksheet.getCell('A3').font = { size: 11, bold: true, color: { argb: '000000' } }; // Text color: Black
    worksheet.getCell('A3').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'F5F5F5' }, // Background color: Whitesmoke
    };
    // Set column widths
    worksheet.columns = [
      { key: 'A', width: 10 },  // Column A: S.No
      { key: 'B', width: 20 },  // Column B: District/Subdivision/Block/Panchayat
      { key: 'C', width: 25 },  // Column C: e-POS Stock Rice
      { key: 'D', width: 25 },  // Column D: e-POS Stock Wheat
      { key: 'E', width: 25 },  // Column E: Physical Stock Rice
      { key: 'F', width: 25 },  // Column F: Physical Stock Wheat
      { key: 'G', width: 25 },  // Column G: Difference Rice
      { key: 'H', width: 25 },  // Column H: Difference Wheat
    ];

    // Define tableData based on the current level
    let tableData = [];

    // Function to generate common table data
    const generateTableData = (data) => {
      return data.map((item, index) => ({
        no: index + 1,
        name: capitalizeFirstLetter(item.name),
        eposStockRice: formatNumber(item.eposRice),
        eposStockWheat: formatNumber(item.eposWheat),
        physicalStockRice: formatNumber(item.physicalRice),
        physicalStockWheat: formatNumber(item.physicalWheat),
        diffRice: formatNumber(Math.abs(item.deviationRicePercent)),
        diffWheat: formatNumber(Math.abs(item.deviationWheatPercent)),
      }));
    };

    // Based on the current level, map data accordingly
    if (currentLevel === "district") {
      tableData = generateTableData(districtData);
    } else if (currentLevel === "subdivision") {
      tableData = generateTableData(filteredData);
    } else if (currentLevel === "block") {
      tableData = generateTableData(filteredData);
    } else if (currentLevel === "panchayat") {
      tableData = generateTableData(panchayats);
    }

    // Function to create and style headers
    const createHeaders = (level) => {
      let headerRow, subHeaderRow;

      if (level === "district" || level === "subdivision" || level === "block" || level === "panchayat") {
        headerRow = [
          "S.No",
          capitalizeFirstLetter(level),
          "e-POS Stock(Qtl)", " ", "Physically Stock(Qtl)", " ",
          "Difference in ePos and Physical Stock (Qtl)", " "
        ];

        // Sub-header (merged cells)
        subHeaderRow = [
          "", "", "Rice", "Wheat", "Rice", "Wheat", "Rice", "Wheat"
        ];
      }

      // Add header row to worksheet
      worksheet.addRow(headerRow);

      // Add sub-header row with merged cells and styling
      const subHeaderCells = worksheet.addRow(subHeaderRow);
      worksheet.mergeCells('C4:D4');
      worksheet.mergeCells('E4:F4');
      worksheet.mergeCells('G4:H4');

      // Set the styling for header and sub-header cells
      const headerCells = ['A4', 'B4', 'C4', 'D4', 'E4', 'F4', 'G4', 'H4'];

      headerCells.forEach(cell => {
        const headerCell = worksheet.getCell(cell);
        headerCell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFA500' } // Orange color
        };
        headerCell.font = { bold: true };
        headerCell.alignment = { vertical: 'middle', horizontal: 'center' };
      });

      // Set background color for sub-header row (orange)
      subHeaderCells.eachCell((cell, colIndex) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFA500' }
        };
      });
    };

    // Create headers based on current level
    createHeaders(currentLevel);

    // Add table data rows with appropriate alignment
    tableData.forEach(row => {
      worksheet.addRow([
        row.no,
        capitalizeFirstLetter(row.name.trim()),
        row.eposStockRice,
        row.eposStockWheat,
        row.physicalStockRice,
        row.physicalStockWheat,
        `${(Math.abs(row.diffRice).toFixed(2))}%`, // Format with 2 decimals and add '%'
        `${(Math.abs(row.diffWheat).toFixed(2))}%`, // Format with 2 decimals and add '%'
      ]);

      // Apply left alignment for text and right alignment for numbers
      worksheet.getCell(`A${worksheet.lastRow.number}`).alignment = { vertical: 'middle', horizontal: 'center' };
      worksheet.getCell(`B${worksheet.lastRow.number}`).alignment = { vertical: 'middle', horizontal: 'left' };
      worksheet.getCell(`C${worksheet.lastRow.number}`).alignment = { vertical: 'middle', horizontal: 'right' };
      worksheet.getCell(`D${worksheet.lastRow.number}`).alignment = { vertical: 'middle', horizontal: 'right' };
      worksheet.getCell(`E${worksheet.lastRow.number}`).alignment = { vertical: 'middle', horizontal: 'right' };
      worksheet.getCell(`F${worksheet.lastRow.number}`).alignment = { vertical: 'middle', horizontal: 'right' };
      worksheet.getCell(`G${worksheet.lastRow.number}`).alignment = { vertical: 'middle', horizontal: 'right' };
      worksheet.getCell(`H${worksheet.lastRow.number}`).alignment = { vertical: 'middle', horizontal: 'right' };
    });

    // Write Excel file to a buffer
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `TPDS Deviation_Report_${formattedDate}.xlsx`; // Add formatted date to filename
      link.click();
    });
  };





  const goBack = () => {
    if (currentLevel === "panchayat") {
      setCurrentLevel("block"); // Go back to block from panchayat
    } else if (currentLevel === "block") {
      setCurrentLevel("subdivision"); // Go back to subdivision from block
    } else if (currentLevel === "subdivision") {
      setCurrentLevel("district"); // Go back to district from subdivision
    }
  };
  const handleDistrictClick = (district) => {
    setSelectedDistrict(district.name);
    setCurrentLevel("subdivision");

    // Fetch subdivision data based on the district UID
    fetchSubDivisionData(district.uid);
  };

  const handleSubDivisionClick = (subDivision) => {
    setSelectedSubDivision(subDivision.name);  // Set the selected subdivision
    setCurrentLevel("block");  // Switch to block level
    fetchBlockData(subDivision.uid);  // Fetch block data
  };



  const handleBlockClick = (blocks) => {
    setSelectedBlock(blocks.name);
    setCurrentLevel("panchayat");
    fetchPanchayatData(blocks.uid); // Fetch data for panchayats
  };


  const capitalizeFirstLetter = (text) => {
    // Check if the text is defined and not empty
    if (text && typeof text === 'string') {
      return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    }
    return ''; // Return an empty string if text is undefined or not a string
  };
  return (
    <div className="tpds-details-1">
      <div className="tpds-details-repo">
        <div className="tpds-details-header-15">
          <button className="tpds-detailscreateUser-btn" onClick={downloadPDF}>
            DOWNLOAD PDF
          </button>
          <button className="tpds-detailscreateUser-btn" onClick={downloadExcel}>
            DOWNLOAD XLSX
          </button>
        </div>
        <div className='tpds-deviations-1 '><h3>TPDS Deviation in Stock Quantity (Qtl)</h3>
        </div>
        {/* District Table */}
        <div className='tpds-table-scroll-deviation'>
          {currentLevel === "district" && (
            <table className="tpds-details-table-home">
              <thead className="tpds-details-head-home">
                <tr>
                  <th rowSpan="2">S.No</th>
                  <th rowSpan="2">District</th>
                  <th colSpan="2">e-POS Stock (Qtl)</th>
                  <th colSpan="2">Physically Verified Quantity(Qtl)</th>
                  <th colSpan="2">% of Deviation in Stock Quantity (Qtl)</th>
                </tr>
                <tr>
                  <th>Rice</th>
                  <th>Wheat</th>
                  <th>Rice</th>
                  <th>Wheat</th>
                  <th>Rice</th>
                  <th>Wheat</th>
                </tr>
              </thead>

              <tbody className="tpds-details-tbody-tr">
                {districtData.map((district, index) => (
                  <tr key={district.uid} onClick={() => handleDistrictClick(district)}>
                    <td>{index + 1}</td>
                    <td>{capitalizeFirstLetter(district.name)}</td>
                    <td>{Math.abs(district.eposRice).toFixed(2)}</td>
                    <td>{Math.abs(district.eposWheat).toFixed(2)}</td>
                    <td>{Math.abs(district.physicalRice).toFixed(2)}</td>
                    <td>{Math.abs(district.physicalWheat).toFixed(2)}</td>
                    <td>{Math.abs(district.deviationRicePercent).toFixed(2)}%</td>
                    <td>{Math.abs(district.deviationWheatPercent).toFixed(2)}%</td>
                  </tr>
                ))}
              </tbody>

            </table>
          )}

          {currentLevel === "subdivision" && (
            <div className="tpds-subdivision-table">
              <button onClick={goBack} className="tpds-back-button">Back</button>
              <h3>{capitalizeFirstLetter(selectedDistrict)}</h3>
              <table className="tpds-details-table-home">
                <thead className="tpds-details-head-home">
                  <tr>
                    <th rowSpan="2">S.No</th>
                    <th rowSpan="2">Sub-Division</th>
                    <th colSpan="2">e-POS Stock (Qtl)</th>
                    <th colSpan="2">Physically Verified Quantity(Qtl)</th>
                    <th colSpan="2">% of Deviation in Stock Quantity (Qtl)</th>
                  </tr>
                  <tr>
                    <th>Rice</th>
                    <th>Wheat</th>
                    <th>Rice</th>
                    <th>Wheat</th>
                    <th>Rice</th>
                    <th>Wheat</th>
                  </tr>
                </thead>
                <tbody className="tpds-details-tbody-tr">
                  {subDivisions.map((subDivision, index) => (
                    <tr key={subDivision.uid} onClick={() => handleSubDivisionClick(subDivision)}>
                      <td>{index + 1}</td>
                      <td>{capitalizeFirstLetter(subDivision.name)}</td>
                      <td>{Math.abs(subDivision.eposRice).toFixed(2)}</td>
                      <td>{Math.abs(subDivision.eposWheat).toFixed(2)}</td>
                      <td>{Math.abs(subDivision.physicalRice).toFixed(2)}</td>
                      <td>{Math.abs(subDivision.physicalWheat).toFixed(2)}</td>
                      <td>{Math.abs(subDivision.deviationRicePercent).toFixed(2)}%</td>
                      <td>{Math.abs(subDivision.deviationWheatPercent).toFixed(2)}%</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {currentLevel === "block" && (
            <div className="tpds-block-table">
              <button onClick={goBack} className="tpds-back-button">Back</button>
              <h3>{capitalizeFirstLetter(selectedDistrict)} - {capitalizeFirstLetter(selectedSubDivision)}</h3>
              <table className="tpds-details-table-home">
                <thead className="tpds-details-head-home">
                  <tr>
                    <th rowSpan="2">S.No</th>
                    <th rowSpan="2">Block</th>
                    <th colSpan="2">e-POS Stock (Qtl)</th>
                    <th colSpan="2">Physically Verified Quantity(Qtl)</th>
                    <th colSpan="2">% of Deviation in Stock Quantity (Qtl)</th>
                  </tr>
                  <tr>
                    <th>Rice</th>
                    <th>Wheat</th>
                    <th>Rice</th>
                    <th>Wheat</th>
                    <th>Rice</th>
                    <th>Wheat</th>
                  </tr>
                </thead>
                <tbody className="tpds-details-tbody-tr">
                  {blocks.map((blocks, index) => (
                    <tr key={blocks.uid} onClick={() => handleBlockClick(blocks)}>
                      <td>{index + 1}</td>
                      <td>{capitalizeFirstLetter(blocks.name)}</td>
                      <td>{Math.abs(blocks.eposRice).toFixed(2)}</td>
                      <td>{Math.abs(blocks.eposWheat).toFixed(2)}</td>
                      <td>{Math.abs(blocks.physicalRice).toFixed(2)}</td>
                      <td>{Math.abs(blocks.physicalWheat).toFixed(2)}</td>
                      <td>{Math.abs(blocks.deviationRicePercent).toFixed(2)}%</td>
                      <td>{Math.abs(blocks.deviationWheatPercent).toFixed(2)}%</td>
                    </tr>
                  ))}
                  {/* Add more rows as necessary */}
                </tbody>
              </table>
            </div>
          )}

          {currentLevel === "panchayat" && (
            <div className="tpds-panchayat-table">
              <button onClick={goBack} className="back-button">Back</button>
              <h3>{capitalizeFirstLetter(selectedDistrict)} - {capitalizeFirstLetter(selectedSubDivision)} - {capitalizeFirstLetter(selectedBlock)}</h3>
              <table className="tpds-details-table-home">
                <thead className="tpds-details-head-home">
                  <tr>
                    <th rowSpan="2">S.No</th>
                    <th rowSpan="2">Panchayat</th>
                    <th colSpan="2">e-POS Stock (Qtl)</th>
                    <th colSpan="2">Physically Verified Quantity(Qtl)</th>
                    <th colSpan="2">% of Deviation in Stock Quantity (Qtl)</th>
                  </tr>
                  <tr>
                    <th>Rice</th>
                    <th>Wheat</th>
                    <th>Rice</th>
                    <th>Wheat</th>
                    <th>Rice</th>
                    <th>Wheat</th>
                  </tr>
                </thead>
                <tbody className="tpds-details-tbody-tr">
                  {panchayats.map((panchayat, index) => (
                    <tr key={panchayat.uid}>
                      <td>{index + 1}</td>
                      <td>{capitalizeFirstLetter(panchayat.name.trim())}</td>
                      <td>{Math.abs(panchayat.eposRice).toFixed(2)}</td>
                      <td>{Math.abs(panchayat.eposWheat).toFixed(2)}</td>
                      <td>{Math.abs(panchayat.physicalRice).toFixed(2)}</td>
                      <td>{Math.abs(panchayat.physicalWheat).toFixed(2)}</td>
                      <td>{Math.abs(panchayat.deviationRicePercent).toFixed(2)}%</td>
                      <td>{Math.abs(panchayat.deviationWheatPercent).toFixed(2)}%</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

        </div>
      </div>
    </div>
  );
};

export default TPDSDeviation;